export class Base {
	constructor(obj) {
		if (!obj) return;

		this.id = obj.id;
		this.createdAt = obj.createdAt;
		this.updatedAt = obj.updatedAt;
	}
}

export default Base;
